// import external dependencies
import "jquery";

// Import everything from autoload
import "./autoload/_bootstrap.js";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";
import documentation from "./routes/documentation";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  documentation,
});

// Load Events
// jQuery(document).ready(() => routes.loadEvents());


jQuery(document).ready(() => {
  routes.loadEvents();

  if(jQuery('#flipdownglobban').length > 0) {
  var theStamp = jQuery('#flipdownglobban').data('end-date');
  new FlipDown(theStamp, "flipdownglobban").start();
  }

  if(jQuery('#flipdownglobbanpop').length > 0) {
    var theStampPopup = jQuery('#flipdownglobbanpop').data('end-date');
    new FlipDown(theStampPopup, "flipdownglobbanpop").start();
  }
});

jQuery('.exptext').on('click', function() {
  jQuery(this).hide();
  jQuery('.sale-badge-text-expanded').show();
});



if(jQuery('.popupfull').length > 0) {
  if(document.cookie.indexOf('popup_shown=true') === -1) {
    setTimeout(function() {
      jQuery('.popupfull').addClass('popupfullshow');
    }, 5000);
  }
}


jQuery('.popupbg, .popupcloser').on('click', function() {
  jQuery('.popupfull').removeClass('popupfullshow');

  // Set 7 day cookie for popup_shown
  var date = new Date();
  date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
  document.cookie = "popup_shown=true; expires=" + date.toUTCString() + "; path=/";
});


// WEBPACK FOOTER //
// ./scripts/main.js